import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ObjectType } from '@/@types/graphql-types';
import { TitleDetailsNode } from '@/interfaces/title-details-graphql';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';

import HorizontalTitleListGraphql from '@/components/timeline/HorizontalTitleListGraphql.vue';

type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

interface SeasonsListProps {
	title: WithRequired<TitleDetailsNode, 'seasons'>;
	additionalContexts: SnowplowContext[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SeasonsList',
  props: {
    title: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: WithRequired<TitleDetailsNode, 'seasons'>, additionalContexts: SnowplowContext[] }



const seasons = computed(() => props.title.seasons ?? []);

function trackSeasonTitleClicked({ index, title }: { index: number; title: TitleDetailsNode }) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'title_clicked', label: `${title.content.seasonNumber}`, property: 'season', value: `${index}` },
		[
			new SnowplowTitleContextGraphql(title.objectId, ObjectType.ShowSeason, title.content.seasonNumber),
			...props.additionalContexts,
		]
	);
}

return { __sfc: true,props, seasons, trackSeasonTitleClicked, HorizontalTitleListGraphql }
}

})